import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'
import createReactClass from 'create-react-class'

import { GetText } from 'lib/gettext'
import { CheckMark, Chevron } from 'common'
import CollapsibleContainer from 'legacy/libs/components/collapsible-container'

export default createReactClass({
  displayName: 'CollapsibleStepContainer',

  propTypes: {
    title: PropTypes.string,
    children: PropTypes.node,
  },

  contextTypes: {
    form: PropTypes.object,
  },

  isFormDirty() {
    // TODO: Simplify this method after react-form-tools issue-12 will be implemented
    // Currently this method is based only on errors (not whole form dirty state at all)
    const form = this.context.form
    const erroneousFields = _.keys(form.getValidationErrors())

    return _.some(erroneousFields, form.isDirty)
  },

  renderStatus() {
    if (!this.context.form) {
      return null
    }

    if (this.context.form.isValid()) {
      return (
        <span className="uppercase text-success-dark">
          <CheckMark className="inline-block stroke-success-dark align-baseline" />{' '}
          <GetText>Complete</GetText>
        </span>
      )
    }

    if (this.isFormDirty()) {
      return (
        <span className="uppercase text-warning-dark">
          <GetText>Incomplete</GetText>
        </span>
      )
    }

    return null
  },

  render() {
    return (
      <CollapsibleContainer
        {...this.props}
        chevron={
          <Chevron
            className="mt-0.5 mr-4 shrink-0"
            rotateWhen={!this.props.cursor.get()}
            size="large"
          />
        }
        header={
          <>
            <h2 className="text-lg font-bold">{this.props.title}</h2>
            <p>{this.renderStatus()}</p>
          </>
        }
        headerClassName={classNames(
          'relative py-4 px-4 sm:px-8 bg-black/5 shadow-[inset_0_1px_0_0] shadow-black/10 transition-[padding]',
          {
            'py-4': this.props.cursor.get(),
            'py-6': !this.props.cursor.get(),
          }
        )}
      >
        {this.props.children}
      </CollapsibleContainer>
    )
  },
})
